import * as R from 'ramda';
import React, { useContext } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { IconBookmark, IconBookmarkFilled } from '@xingternal/icons';

import { JobDetailContext } from '@/contexts';
import { useJobUserInteractionsQuery } from '@/graphql/generated';
import { useBookmark, useBreakpoints } from '@/hooks';

import * as S from './bookmark-action-container.styles';

export const NOT_BOOKMARKED = 'NOT_BOOKMARKED';
export const SAVED = 'SAVED';

type Props = {
  isSticky?: boolean;
  isIconButton?: boolean;
};
// isIconButton prop is part of ABACUS-411 implementation
export const BookmarkAction: React.FC<Props> = ({ isSticky, isIconButton = false }) => {
  const { slug, id } = useContext(JobDetailContext);
  const intl = useIntl();

  const { isMobile } = useBreakpoints();

  const isWideButton = !isMobile && !isSticky && !isIconButton;

  const { data, loading, error } = useJobUserInteractionsQuery({
    variables: { slug },
  });
  const isBookmarked =
    R.pathOr(NOT_BOOKMARKED, ['job', 'userInteractions', 'bookmark', 'state'], data) !== NOT_BOOKMARKED;

  const toggleBookmark = useBookmark({
    jobId: id,
    isBookmarked,
    nwtTrackingOptions: {
      page: 'jobs/detail',
      event_schema: 'basic',
    },
  });

  if (error) return null;
  return (
    <S.StyledBookmarkActionContainer
      $isWideButton={isWideButton}
      variant="secondary"
      data-cy={isBookmarked ? 'bookmarked-button' : 'unbookmarked-button'}
      size="medium"
      loading={loading}
      {...(loading && { 'data-testid': 'bookmark-button-loading' })}
      onClick={() => toggleBookmark()}
      aria-label={intl.formatMessage({
        id: isBookmarked ? 'JOBS_POSTING_ACTIONS_SAVED_HEADER_BUTTON' : 'JOBS_POSTING_ACTIONS_SAVE_HEADER_BUTTON',
      })}
      icon={isBookmarked ? IconBookmarkFilled : IconBookmark}
    >
      {isWideButton ? (
        <FormattedMessage
          id={isBookmarked ? 'JOBS_POSTING_ACTIONS_SAVED_HEADER_BUTTON' : 'JOBS_POSTING_ACTIONS_SAVE_HEADER_BUTTON'}
        />
      ) : null}
    </S.StyledBookmarkActionContainer>
  );
};
